import { render, staticRenderFns } from "./CreateAndModifyPopup.vue?vue&type=template&id=6c5b2f6d"
import script from "./CreateAndModifyPopup.vue?vue&type=script&lang=js"
export * from "./CreateAndModifyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports